import { Injectable } from '@angular/core';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  constructor(private remoteConfig: AngularFireRemoteConfig) {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      await this.remoteConfig.fetchAndActivate();
    } catch (error) {
      console.error('Error initializing Remote Config:', error);
    }
  }

  async isEnabled(flagName: string): Promise<boolean> {
    try {
      return (await this.remoteConfig.getValue(flagName)).asBoolean();
    } catch (error) {
      return false;
    }
  }
}
